/**
 * Fabpad PDP — Mega Savings Combo bundle.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-pdp-mega-combo]');
    if (!root) return;

    var configEl = document.querySelector('[data-mega-combo-config]');
    var discountPct = 15;
    var slotCount = parseInt(root.dataset.megaSlotCount || '3', 10);
    var currentSlotIndex = parseInt(root.dataset.megaCurrentSlot || String(slotCount), 10);
    var moneyFormat = '{"amount":{{amount}}}';

    if (configEl) {
      try {
        var config = JSON.parse(configEl.textContent);
        discountPct = parseInt(config.discountPct || '15', 10);
        slotCount = parseInt(config.slotCount || slotCount || '3', 10);
        if (config.currentSlot) currentSlotIndex = parseInt(config.currentSlot, 10);
        moneyFormat = config.moneyFormat || moneyFormat;
      } catch (e) { /* keep defaults */ }
    }

    var slots = [];
    for (var s = 1; s <= slotCount; s += 1) slots.push(s);

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return '₹' + (cents / 100).toFixed(2);
    }

    function getSelectedVariantData(slot) {
      var field = root.querySelector('[data-mega-combo-variant][data-slot="' + slot + '"]');
      if (!field) return null;

      if (field.tagName === 'SELECT') {
        var option = field.options[field.selectedIndex];
        if (!option || !option.value) return null;
        return {
          id: option.value,
          price: parseInt(option.dataset.price || '0', 10),
          compare: parseInt(option.dataset.compare || option.dataset.price || '0', 10)
        };
      }

      return {
        id: field.value,
        price: parseInt(field.dataset.price || '0', 10),
        compare: parseInt(field.dataset.compare || field.dataset.price || '0', 10)
      };
    }

    function updatePricing() {
      var subtotal = 0;
      var compareTotal = 0;
      var allAvailable = true;

      slots.forEach(function (slot) {
        var data = getSelectedVariantData(slot);
        if (!data) return;
        subtotal += data.price;
        compareTotal += data.compare > data.price ? data.compare : data.price;

        var item = root.querySelector('[data-mega-combo-item][data-slot="' + slot + '"]');
        if (!item) return;

        var priceEl = item.querySelector('[data-mega-item-price]');
        var compareEl = item.querySelector('[data-mega-item-compare]');
        if (priceEl) priceEl.textContent = formatMoney(data.price);
        if (compareEl) {
          if (data.compare > data.price) {
            compareEl.textContent = formatMoney(data.compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        var field = root.querySelector('[data-mega-combo-variant][data-slot="' + slot + '"]');
        if (field && field.tagName === 'SELECT') {
          var option = field.options[field.selectedIndex];
          if (option && option.disabled) allAvailable = false;
        }
      });

      var bundleTotal = Math.round(subtotal * (100 - discountPct) / 100);
      var saveAmount = compareTotal - bundleTotal;
      if (saveAmount < 0) saveAmount = subtotal - bundleTotal;

      var totalEl = root.querySelector('[data-mega-combo-total]');
      var compareEl = root.querySelector('[data-mega-combo-compare]');
      var saveEl = root.querySelector('[data-mega-combo-save]');
      var atcBtn = root.querySelector('[data-mega-combo-atc]');

      if (totalEl) totalEl.textContent = formatMoney(bundleTotal);
      if (compareEl) {
        if (compareTotal > bundleTotal) {
          compareEl.textContent = formatMoney(compareTotal);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) saveEl.textContent = formatMoney(saveAmount);
      if (atcBtn) atcBtn.disabled = !allAvailable;
    }

    root.querySelectorAll('[data-mega-combo-variant]').forEach(function (field) {
      field.addEventListener('change', updatePricing);
    });

    var atcBtn = root.querySelector('[data-mega-combo-atc]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var items = [];
        slots.forEach(function (slot) {
          var data = getSelectedVariantData(slot);
          if (data && data.id) items.push({ id: data.id, quantity: 1 });
        });
        if (items.length < slotCount) return;

        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';

        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function (data) {
            var after = window.FabpadCart && window.FabpadCart.afterAdd
              ? window.FabpadCart.afterAdd(data)
              : Promise.resolve();
            return after.then(function () {
              atcBtn.textContent = 'Added ✓';
              window.setTimeout(function () {
                atcBtn.disabled = false;
                atcBtn.textContent = 'Add to cart';
              }, 800);
            });
          })
          .catch(function () {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to cart';
          });
      });
    }

    document.addEventListener('fabpad:variant-change', function () {
      var pdpVariantInput = document.querySelector('[data-variant-id]');
      var currentSlot = root.querySelector('[data-mega-combo-variant][data-slot="' + currentSlotIndex + '"]');
      if (!pdpVariantInput || !currentSlot || currentSlot.tagName !== 'SELECT') return;
      currentSlot.value = pdpVariantInput.value;
      updatePricing();
    });

    updatePricing();
  });
})();
